import {ExternalLinkIcon} from '@heroicons/react/outline';
import React from 'react';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Button, Link, Swap} from '@/components';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import type {AdminAfriexPerson} from '@/types';

import FundUserWallet from './FundUserWallet';
import type {UserDetailsReturnProps} from './types';
import UserWalletBalance from './UserWalletBalance';

type TransactionViewProps = Pick<
  UserDetailsReturnProps,
  'walletBalances' | 'isLoadingWalletBalances'
>;

const TransactionsView: React.FC<
  TransactionViewProps & {
    user: AdminAfriexPerson;
  }
> = ({walletBalances, isLoadingWalletBalances, user}) => {
  return (
    <div className="px-3 pt-3 mt-8">
      <h3 className="font-semibold text-gray-900 dark:text-gray-300 mb-2">
        {'Transactions'.toLocaleUpperCase()}
      </h3>
      <hr className="mb-5 dark:border-dark-borderMid" />

      <div className="flex flex-col md:flex-row justify-between">
        <UserWalletBalance
          isLoadingWalletBalances={isLoadingWalletBalances}
          walletBalances={walletBalances}
        />

        <PermissionsProvider
          permission={AfriexAdminPermission.TransactionLedgerCreate}
        >
          <FundUserWallet user={user} />
        </PermissionsProvider>
      </div>

      <div className="flex flex-col mt-5 gap-3 md:w-4/12">
        <PermissionsProvider
          permission={AfriexAdminPermission.TransactionSwapCreate}
        >
          <Swap userId={user.id} key={user.id} />
        </PermissionsProvider>

        <PermissionsProvider
          permission={AfriexAdminPermission.UserTransactionRead}
        >
          <Link
            to={`/transactions/user/${user.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-max"
          >
            <Button
              colorScheme="cyan"
              variant="ghost"
              rightIcon={<ExternalLinkIcon className="w-5 h-5" />}
              className="no-padding"
            >
              View user transactions
            </Button>
          </Link>
        </PermissionsProvider>
      </div>
    </div>
  );
};

export default TransactionsView;
